(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        // For "mega-nav" on large screens, we do not allow toggling via summary clicks.
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /*
    MOBILE-ONLY STICKY HEADER:
    --------------------------------
    - Hide on scroll down, show on scroll up, but only after 300px from top.
    - If predictive search is open, keep the header visible until scrolled
      at least 100px from the point at which search was opened.
    - A placeholder <div> matches the header’s height to avoid jump.
  */
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('store-header.header');
    const placeholder = document.querySelector('.header-placeholder');

    let lastScrollY = window.scrollY;
    let wasSearchOpen = false;
    let searchOpenScrollY = 0;
    let headerHeight = 0;

    // Function to check if predictive search is open
    function isSearchOpen() {
      // 'overlay-predictive-search' is toggled by predictive-search.js
      return document.body.classList.contains('overlay-predictive-search');
    }

    // Measure the header in a "clean" state to get its natural height
    function measureHeaderHeight() {
      const wasSticky = header.classList.contains('sticky');
      const wasHide = header.classList.contains('hide');
      const wasAtTop = header.classList.contains('at-top');

      // Temporarily remove classes that affect offsetHeight
      header.classList.remove('sticky', 'hide', 'at-top');

      const measured = header.offsetHeight;

      // Restore classes
      if (wasSticky) header.classList.add('sticky');
      if (wasHide) header.classList.add('hide');
      if (wasAtTop) header.classList.add('at-top');

      return measured;
    }

    // Update the placeholder’s height only when the header is sticky
    function updatePlaceholder() {
      if (header.classList.contains('sticky')) {
        placeholder.style.display = 'block';
        placeholder.style.height = headerHeight + 'px';
      } else {
        placeholder.style.display = 'none';
      }
    }

    // Main scroll logic for mobile
    function updateHeader() {
      const currentScrollY = window.scrollY;
      const searchOpen = isSearchOpen();

      // If search just opened, store that scroll position
      if (searchOpen && !wasSearchOpen) {
        searchOpenScrollY = currentScrollY;
      }
      wasSearchOpen = searchOpen;

      // If predictive search is open and user hasn't scrolled 100px yet, pin the header
      if (searchOpen && Math.abs(currentScrollY - searchOpenScrollY) < 100) {
        header.classList.add('sticky');
        header.classList.remove('hide', 'at-top');
        updatePlaceholder();
        lastScrollY = currentScrollY;
        return;
      }

      // Threshold: 300px from top
      if (currentScrollY < 300) {
        // Near top: header in normal flow
        header.classList.add('at-top');
        header.classList.remove('sticky', 'hide');
      } else {
        // Past threshold -> sticky
        header.classList.add('sticky');
        header.classList.remove('at-top');

        // Determine scroll direction
        if (currentScrollY > lastScrollY) {
          // Scrolling down
          header.classList.add('hide');
        } else {
          // Scrolling up
          header.classList.remove('hide');
        }
      }
      updatePlaceholder();
      lastScrollY = currentScrollY;
    }

    function onResizeOrLoad() {
      // Check if we are on desktop
      if (window.matchMedia(theme.mediaQueries.md).matches) {
        // Desktop: remove sticky/hide classes, no scroll handling
        header.classList.remove('sticky', 'hide', 'at-top');
        placeholder.style.display = 'none';
        window.removeEventListener('scroll', updateHeader);
      } else {
        // Mobile: measure header height and bind scroll logic
        headerHeight = measureHeaderHeight();
        window.addEventListener('scroll', updateHeader, { passive: true });

        // Set initial state based on current scroll
        if (window.scrollY < 300) {
          header.classList.add('at-top');
          header.classList.remove('sticky', 'hide');
          placeholder.style.display = 'none';
        } else {
          header.classList.add('sticky');
          header.classList.remove('at-top');
          if (window.scrollY > lastScrollY) {
            header.classList.add('hide');
          } else {
            header.classList.remove('hide');
          }
          updatePlaceholder();
        }
      }
    }

    window.addEventListener('resize', onResizeOrLoad);
    onResizeOrLoad(); // Initialize on load
  });

  } catch(e) { console.error(e); }
})();
})();
